import { render } from "./rms_material_receive.vue?vue&type=template&id=5187bdaf&scoped=true"
import script from "./rms_material_receive.vue?vue&type=script&lang=js"
export * from "./rms_material_receive.vue?vue&type=script&lang=js"

import "./rms_material_receive.vue?vue&type=style&index=0&id=5187bdaf&scoped=true&lang=css"

import exportComponent from "D:\\svn\\esp-rms-xhjr-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5187bdaf"]])

export default __exports__